// Presentation redirect (2026-06-01) — project-only access.
//
// Presentations are viewed INSIDE their project's sub-nav, never as a
// standalone page. Any legacy / bookmarked / global-search / clone link
// to `/presentations/:id` lands here, which resolves the presentation's
// project and forwards to:
//   /projects/:projectId/presentation/:presentationId
//
// Mirrors OrderRedirect (Nav Part 1, PR #160).
import { Navigate, useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

interface RedirectPresentation {
  presentation: { id: string; projectId: string };
}

export function PresentationRedirect() {
  const { id = "" } = useParams<{ id: string }>();
  const { data, isError } = useQuery({
    queryKey: ["presentations", id, "redirect"],
    queryFn: () => api<RedirectPresentation>(`/presentations/${id}`),
    enabled: id.length > 0,
  });

  if (isError) return <Navigate to="/presentations" replace />;
  if (!data) {
    return (
      <div className="px-6 py-24 text-center text-sm text-brown-300">
        Opening presentation…
      </div>
    );
  }

  const { presentation } = data;
  return (
    <Navigate
      to={`/projects/${presentation.projectId}/presentation/${presentation.id}`}
      replace
    />
  );
}
